import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.questions.title',
    defaultMessage: 'SIMULATED EDIT • APPROVE QUESTIONS',
  },
  back: {
    id: 'simulated.questions.back',
    defaultMessage: 'Back',
  },
  continue: {
    id: 'simulated.questions.continue',
    defaultMessage: 'Continue',
  },
  close: {
    id: 'simulated.questions.close',
    defaultMessage: 'Close',
  },
  questions: {
    id: 'simulated.questions.questions',
    defaultMessage: 'Questions',
  },
  search: {
    id: 'simulated.questions.search',
    defaultMessage: 'Search question...',
  },
  showing: {
    id: 'simulated.questions.questions',
    defaultMessage: 'Displaying {quantity} of {total}',
  },
  approvation: {
    id: 'simulated.questions.approvation',
    defaultMessage: 'Approvation',
  },
  approve: {
    id: 'simulated.questions.approve',
    defaultMessage: 'Approve',
  },
  approved: {
    id: 'simulated.questions.approved',
    defaultMessage: 'Question Approved',
  },
  reprove: {
    id: 'simulated.questions.reprove',
    defaultMessage: 'Reprove',
  },
  repproved: {
    id: 'simulated.questions.repproved',
    defaultMessage: 'Disapproved Question',
  },
  repprovedReason: {
    id: 'simulated.questions.repprovedReason',
    defaultMessage: 'Reason Sent',
  },
  approvedMessage: {
    id: 'simulated.questions.approvedMessage',
    defaultMessage: 'The {position} question has been successfully passed!',
  },
  repprovedMessage: {
    id: 'simulated.questions.repprovedMessage',
    defaultMessage:
      'You want to fail the {position} question. Please let us know the reason for your disapproval so we can adjust.',
  },
  repprovedReasonMessage: {
    id: 'simulated.questions.repprovedReasonMessage',
    defaultMessage:
      'The reason for the disapproval of the {position} issue has been successfully submitted. We will soon return.',
  },
  reasonInput: {
    id: 'simulated.questions.reasonInput',
    defaultMessage: 'Enter the reason ...',
  },
  information: {
    id: 'simulated.questions.information',
    defaultMessage: 'Informations',
  },
  generalFeedback: {
    id: 'simulated.questions.generalFeedback',
    defaultMessage: 'General Feedback',
  },
  evaluationApproved: {
    id: 'simulated.questions.evaluationApproved',
    defaultMessage: 'Evaluation Approved',
  },
  evaluationApproveFailed: {
    id: 'simulated.questions.evaluationApproveFailed',
    defaultMessage: 'Evaluation Approvation',
  },
  evaluationApprovedMessage: {
    id: 'simulated.questions.evaluationApprovedMessage',
    defaultMessage:
      'The simulation <strong>{id} - {catalogingsLabel}</strong> was approved and requested for diagramming.',
  },
  evaluationApproveFailedMessage: {
    id: 'simulated.questions.evaluationApproveFailedMessage',
    defaultMessage: 'An error ocurred when trying to approve ',
  },
  error_approveAllQuestionsFirst: {
    id: 'simulated.questions.error_approveAllQuestionsFirst',
    defaultMessage: 'Sorry, all evaluation questions must be approved before proceeding',
  },
  error_generic: {
    id: 'simulated.questions.error_generic',
    defaultMessage: 'An error ocurred',
  },
  and: {
    id: 'simulated.questions.and',
    defaultMessage: 'and',
  },
  bloomTaxanomy: {
    id: 'simulated.questions.bloomTaxanomy',
    defaultMessage: 'Bloom taxanomy',
  },
  charactersLeft: {
    id: 'simulated.questions.charactersLeft',
    defaultMessage: '{number} characters left',
  },
  characters: {
    id: 'simulated.questions.characters',
    defaultMessage: '{count} characteres. At least {number} characters.',
  },
  optional: {
    id: 'simulated.questions.optional',
    defaultMessage: 'Optional',
  },
  questionsLabel: {
    id: 'simulated.questions.questionsLabel',
    defaultMessage: 'Questions',
  },
  forbidden: {
    id: 'simulated.questions.forbidden',
    defaultMessage: 'Content not available.',
  },
  finishValidation: {
    id: 'simulated.questions.finishValidation',
    defaultMessage: 'FINISH VALIDATION',
  },
  proceed: {
    id: 'simulated.questions.proceed',
    defaultMessage: 'Proceed',
  },
  cancel: {
    id: 'simulated.questions.cancel',
    defaultMessage: 'Cancel',
  },
  finishValidationText: {
    id: 'simulated.questions.finishValidationText',
    defaultMessage:
      'Do you want to finalize question validation? If you proceed, it will not be possible to re-validate the questions.',
  },
});
